import {Stack, Paper, Typography, Box} from '@mui/material'
import {ReactComponent as SuccessIcon} from 'src/images/success_icon.svg'
import {useParams} from 'react-router-dom'

const SuccessPage = () => {
  const {id} = useParams() // Extract the Id from the URL parameters

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="98vh"
    >
      <Paper
        elevation={3}
        sx={{
          p: '2rem',
          width: '25%',
          borderRadius: '16px'
        }}
      >
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={2}
        >
          <Stack>
            <SuccessIcon width={318} height={238} />
          </Stack>
          <Typography
            variant="h5"
            sx={{
              fontFamily: 'Heebo',
              pt: '2rem',
              fontWeight: 'bold'
            }}
          >
            המידע עודכן בהצלחה
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontFamily: 'Heebo',
              pt: '2rem',
              textAlign: 'center',
              color: '#637381'
            }}
          >
            {`מס’ בקשה: ${id}.`}
            <br />
            הבקשה נבדקת כעת ע”י מערכת הניהול של ‘קרנה של תורה’.
          </Typography>
        </Stack>
      </Paper>
    </Box>
  )
}

export default SuccessPage
